import React, { useEffect, useState } from "react";
import { FaArrowsRotate } from "react-icons/fa6";
import "./MerchantApiKeys.css";
import { getUserApiKeysData, rotateApiKey } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import RotateMsg from "./RotateMsg";
import ApiIntegrationModal from "./ApiIntegrationModal";
import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";
import { useCallback } from "react";

const ApiTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [showRotateMsg, setShowRotateMsg] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newApiKey, setNewApiKey] = useState(null);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);

  const fetchMerchantApiData = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await getUserApiKeysData(token);

      setUserData(
        response?.data?.filter((user) => user.user?.role === "admin") || [],
      );
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch merchant data.");
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchMerchantApiData();
  }, [fetchMerchantApiData]);

  const handleRotateClick = (user) => {
    setSelectedUser(user);
    setShowRotateMsg(true);
  };

  const handleConfirmRotate = async (userName) => {
    try {
      const newKey = await rotateApiKey(token, selectedUser?.user?.id);
      setNewApiKey(newKey);
      setShowApiKeyModal(true);
      toast.success(`New API key genratre for ${userName}.`);
      setShowRotateMsg(false);
    } catch (error) {
      toast.error("Failed to rotate API key.");
    }
  };

  const handleCancelRotate = () => {
    setShowRotateMsg(false);
  };
  const handleCloseApiKeyModal = () => {
    setShowApiKeyModal(false);
  };

  const columns = [
    {
      key: "merchantName",
      header: "Merchant Name",
      wrapCell: true,
      render: (row) => row?.user?.alias || row?.userId,
    },
    {
      key: "createdAt",
      header: "Created At",
      render: (row) =>
        row.createdAt ? <DateCell date={row.createdAt} /> : "N/A",
    },
    {
      key: "updatedAt",
      header: "Updated At",
      render: (row) =>
        row.updatedAt ? <DateCell date={row.updatedAt} /> : "N/A",
    },
    {
      key: "action",
      header: "Action",
      render: (row) => (
        <FaArrowsRotate
          size={18}
          style={{ cursor: "pointer" }}
          onClick={() => handleRotateClick(row)}
        />
      ),
    },
  ];

  return (
    <div className="webhooks-report-table-container">
      <h2 className="webhooks-report-table-title">Merchant API Keys</h2>
      <DataTable
        columns={columns}
        data={userData}
        loading={isLoading}
        emptyMessage="No admin merchants found."
      />
      {showRotateMsg && selectedUser && (
        <RotateMsg
          username={selectedUser?.user?.name}
          onConfirm={() => handleConfirmRotate(selectedUser?.user?.name)}
          onCancel={handleCancelRotate}
        />
      )}
      {showApiKeyModal && newApiKey && (
        <ApiIntegrationModal
          open={showApiKeyModal}
          handleClose={handleCloseApiKeyModal}
          apiKey={newApiKey}
        />
      )}
    </div>
  );
};

export default ApiTable;
